import * as React from 'react';
import { Button } from '@grandvisionhq/common';

const AddressBookModalFooter = ({ handleAdressSelect , handleOnAddAddress , isLoading , isAddViewActive , labels  })=>/*#__PURE__*/ React.createElement("section", {
        className: "address-book-modal__buttons"
    }, isAddViewActive ? /*#__PURE__*/ React.createElement(Button, {
        caption: labels.save,
        className: "address-book-modal__button",
        form: "add-address",
        isLoading: isLoading,
        key: "save-address",
        size: "custom",
        type: "submit",
        variant: "solid"
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Button, {
        caption: labels.add,
        className: "address-book-modal__button",
        key: "add-address",
        onClick: handleOnAddAddress,
        size: "custom",
        variant: "outline"
    }), /*#__PURE__*/ React.createElement(Button, {
        caption: labels.select,
        className: "address-book-modal__button",
        key: "select-address",
        onClick: handleAdressSelect,
        size: "custom",
        variant: "solid"
    })))
;

export { AddressBookModalFooter };
//# sourceMappingURL=AddressBookModalFooter.js.map
